import { render, staticRenderFns } from "./JoinIndex.vue?vue&type=template&id=df8aa04c"
import script from "./JoinIndex.vue?vue&type=script&lang=js"
export * from "./JoinIndex.vue?vue&type=script&lang=js"
import style0 from "./JoinIndex.vue?vue&type=style&index=0&id=df8aa04c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports